import { createContext, useContext, useEffect, useState } from "react";

const SettingsContext = createContext(null);

const STORAGE_KEY = "gloss.settings.v1";

const DEFAULTS = {
  salon_name: "Lumière Salon & Spa",
  owner_name: "Ms. Aisha Mehta",
  branch_name: "Koregaon Park",
  salon_phone: "+91 98765 12345",
  salon_whatsapp: "+91 98765 12345",
  salon_landline: "020 4321 5678",
  currency: "₹",
  loyalty_rate: 1,
  tip_enabled: true,
  split_billing_enabled: true,
  auto_promote_waitlist: true,
  buffer_minutes_default: 15,
  birthday_voucher_amount: 500,
  display_promo_enabled: true,
  gstin: "27AABCU9603R1ZX",
  gst_rate: 18,
  invoice_prefix: "GLOSS",
  salon_address: "Lane 7, Koregaon Park, Pune 411001",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : DEFAULTS;
    } catch { return DEFAULTS; }
  });

  const updateSettings = (patch) => {
    setSettings((cur) => {
      const next = { ...cur, ...patch };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      // notify other tabs
      window.dispatchEvent(new StorageEvent("storage", { key: STORAGE_KEY, newValue: JSON.stringify(next) }));
      return next;
    });
  };

  useEffect(() => {
    const handler = (e) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        try { setSettings({ ...DEFAULTS, ...JSON.parse(e.newValue) }); } catch {}
      }
    };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
